import GreenPageSection from 'components/GreenPageSection';
import RoundedButton from 'components/RoundedButton';
import Subheading from 'components/Subheading';
import HowItWorksSteps from 'components/common/HowItWorksSteps';
import ReturnToTopOfPageButton from 'components/common/ReturnToTopOfPageButton';
import EntryMethodSelectionSection from 'components/landing/EntryMethodSelectionSection';
import { useState } from 'react';
import { scrollToSection } from 'utils/common';

const View = {
  HOW_IT_WORKS: 'HOW_IT_WORKS',
  CHOOSE_PLAN: 'CHOOSE_PLAN',
};

const HowItWorksAndChoosePlanSection = () => {
  const [activeView, setActiveView] = useState(View.HOW_IT_WORKS);

  if (activeView === View.CHOOSE_PLAN) {
    return (
      <div
        id="howItWorksAndChoosePlanSection"
        className="fullWidth flexCentered"
      >
        <EntryMethodSelectionSection />
      </div>
    );
  }

  return (
    <GreenPageSection id="howItWorksAndChoosePlanSection">
      <Subheading>
        Enter <strong>now</strong>
      </Subheading>

      <p>It's as easy as 1, 2, 3!</p>

      <HowItWorksSteps />

      <RoundedButton
        onClick={() => {
          setActiveView(View.CHOOSE_PLAN);
          scrollToSection('#howItWorksAndChoosePlanSection');
        }}
        style={{ width: 280, margin: '2em 0 1em' }}
      >
        Enter now
      </RoundedButton>

      <ReturnToTopOfPageButton />
    </GreenPageSection>
  );
};

export default HowItWorksAndChoosePlanSection;
